/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'

@Component
export class CommonOperationGuardMixin extends Vue {
    $_canCreateIncidents(entity: any): boolean {
        return entity?.metadata?.operationGuards.canCreateIncidents
    }
    $_canBeAttached(entity: any): boolean {
        return entity?.metadata?.operationGuards.canBeAttached
    }
    $_canBeDeleted(entity: any): boolean {
        return entity?.metadata?.operationGuards.canBeDeleted
    }
    $_canPortionsBeCreated(entity: any): boolean {
        return entity?.metadata?.operationGuards.canPortionsBeCreated
    }
}
